<!-- 'subject'/'preheader' never reach this switch in v2 - they're always-on
     system fields wired directly in preview-v2/edit-block-comments-v2 via
     app-subject-v2/app-preheader-v2, never through the normal block loop. -->
<ng-container [ngSwitch]="block?.name">
  <app-counter-v2
    *ngSwitchCase="'counter'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-counter-v2>

  <app-paragraph-cta-v2
    *ngSwitchCase="'paragraph-cta'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-paragraph-cta-v2>

  <app-voucher-v2
    *ngSwitchCase="'voucher'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-voucher-v2>

  <app-main-banner-v2
    *ngSwitchCase="'main-banner'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    [deviceMode]="deviceMode"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-main-banner-v2>

  <app-gift-voucher-v2
    *ngSwitchCase="'gift-voucher'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-gift-voucher-v2>

  <app-property-usp-2x-photo-v2
    *ngSwitchCase="'property-usp-2x-photo'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-property-usp-2x-photo-v2>

  <app-zigzag-no-heading-no-button-v2
    *ngSwitchCase="'zigzag-no-heading-no-button'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-zigzag-no-heading-no-button-v2>

  <app-zigzag-heading-and-cta-v2
    *ngSwitchCase="'zigzag-heading-and-cta'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-zigzag-heading-and-cta-v2>

  <app-zigzag-heading-and-alt-cta-v2
    *ngSwitchCase="'zigzag-heading-and-alt-cta'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-zigzag-heading-and-alt-cta-v2>

  <app-property-usp-1x-photo-v2
    *ngSwitchCase="'property-usp-1x-photo'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    [deviceMode]="deviceMode"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-property-usp-1x-photo-v2>

  <app-property-description-v2
    *ngSwitchCase="'property-description'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    [deviceMode]="deviceMode"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-property-description-v2>

  <app-x2-prop-rec-v2
    *ngSwitchCase="'x2-prop-rec'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-x2-prop-rec-v2>

  <app-heading-v2
    *ngSwitchCase="'heading'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-heading-v2>

  <app-reservation-v2
    *ngSwitchCase="'reservation'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-reservation-v2>

  <app-event-v2
    *ngSwitchCase="'event'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    [deviceMode]="deviceMode"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-event-v2>

  <app-concierge-v2
    *ngSwitchCase="'experience-concierge'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-concierge-v2>

  <app-check-in-v2
    *ngSwitchCase="'check-in'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-check-in-v2>

  <app-valamar-app-v2
    *ngSwitchCase="'valamar-app'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-valamar-app-v2>

  <app-x2-experiences-v2
    *ngSwitchCase="'x2-experiences'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-x2-experiences-v2>

  <app-x3-experiences-v2
    *ngSwitchCase="'x3-experiences'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-x3-experiences-v2>

  <app-moments-v2
    *ngSwitchCase="'moments'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    [deviceMode]="deviceMode"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-moments-v2>

  <app-inspiration-v2
    *ngSwitchCase="'inspiration'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-inspiration-v2>

  <app-x2-prop-rec-onp-v2
    *ngSwitchCase="'x2-prop-rec-onp'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-x2-prop-rec-onp-v2>

  <app-reviews-v2
    *ngSwitchCase="'reviews'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-reviews-v2>

  <app-only-cta-v2
    *ngSwitchCase="'only-cta'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-only-cta-v2>

  <app-disclaimer-v2
    *ngSwitchCase="'disclaimer'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-disclaimer-v2>

  <app-only-intro-v2
    *ngSwitchCase="'only-intro'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-only-intro-v2>

  <app-only-2-photos-v2
    *ngSwitchCase="'only-2-photos'"
    [block]="block"
    [isPreview]="isPreview"
    [disabled]="disabled"
    (blockData)="onBlockData($event)"
    (removeBlockEvent)="onRemoveBlock($event)"
  ></app-only-2-photos-v2>
</ng-container>
